import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { listSessions } from "@/lib/storage";

function greeting() {
  const h = new Date().getHours();
  if (h < 5) return "It's late.";
  if (h < 12) return "Good morning.";
  if (h < 17) return "Good afternoon.";
  if (h < 21) return "Good evening.";
  return "Winding down.";
}

export default function Home() {
  const navigate = useNavigate();
  const sessions = useMemo(() => listSessions(), []);

  return (
    <div className="flex flex-col min-h-[100dvh] px-8 pt-24 pb-12 pb-safe">
      <div data-testid="brand" className="text-xs uppercase tracking-[0.35em] text-still-muted">
        Stillroom
      </div>

      <h1
        data-testid="greeting"
        className="no-wrap-greeting font-serif text-4xl sm:text-5xl md:text-6xl font-light mt-10 leading-[1.05] text-still-fg"
      >
        {greeting()}
      </h1>
      <p className="font-serif italic text-2xl mt-3 text-still-muted">
        A quiet room for whatever&apos;s on your mind.
      </p>

      <div className="mt-auto flex flex-col gap-4">
        <button
          data-testid="talk-it-out-btn"
          onClick={() => navigate("/start")}
          className="w-full rounded-full bg-still-fg text-still-bg py-5 text-lg font-medium transition-transform duration-200 hover:scale-[1.01] active:scale-[0.98]"
        >
          Talk it out
        </button>
        {sessions.length > 0 && (
          <button
            data-testid="past-sessions-link"
            onClick={() => navigate("/history")}
            className="w-full text-still-muted text-sm hover:text-still-fg py-3 transition-colors"
          >
            Your past sessions →
          </button>
        )}
      </div>
    </div>
  );
}
